import {
  takeEvery, call, put,
} from "redux-saga/effects";
import { addNotification } from "@fas/ui-framework";
import { GET_REDIRECT_SAGA, GET_REDIRECT_LOADING } from "../../helpers/constants";
import RedirectApi from "../../services/redirectApi";
import { setRedirect } from "../../actions/redirectInfo";
import setLoading from "../../actions/loading";
import type { GetRedirectSagaAction } from "../../actions/redirect";
import type { RedirectLoadingTypes as LoadingTypes } from "../../actions/loading";
import type { Redirect } from "../../reducers/redirectList";

export function* makeFetch(action: GetRedirectSagaAction) {
  try {
    yield put(setLoading<LoadingTypes>(GET_REDIRECT_LOADING, true));
    const { id }: GetRedirectSagaAction = action;

    const response: {
      data: {
        result: Redirect,
      },
    } = yield call(RedirectApi.getRedirect, id);
    const { data: { result: redirect } } = response;

    yield put(setRedirect(redirect));
  }
  catch (error: any) {
    yield put(addNotification({ message: error.errorMessage || "Failed to fetch redirect", severity: "error" }));
    // eslint-disable-next-line no-console
    console.error(error);
  }
  finally {
    yield put(setLoading<LoadingTypes>(GET_REDIRECT_LOADING, false));
  }
}

export default function* watch() {
  yield takeEvery(GET_REDIRECT_SAGA, makeFetch);
}
